import type { SessionJig } from '@features/workshop-plan/types';

/** Rank of a jig in the creation dialog: free machines first, then busy ones, blocked ones last. */
const rank = (jig: SessionJig): number => {
  if (jig.blocked) return 2;
  return jig.ongoingSessions.length > 0 ? 1 : 0;
};

/** Jigs in the order they are offered (stable within a rank). */
export const sortJigs = (jigs: SessionJig[]): SessionJig[] => [...jigs].sort((a, b) => rank(a) - rank(b));

/**
 * Jig of the session: the one the operator chose if it can still be used, otherwise the first free one, otherwise the
 * first one not blocked. `null` when every machine is blocked.
 */
export const pickJig = (jigs: SessionJig[], chosenId: number | null): SessionJig | null => {
  const chosen = jigs.find((jig) => jig.id === chosenId && !jig.blocked);

  return chosen ?? sortJigs(jigs).find((jig) => !jig.blocked) ?? null;
};
